import Vue from "vue";
import VueRouter from "vue-router";

// START: Widget Views
import ChatWidget from "@/widget/Index";
// END: Widget Views

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/widget/app",
      name: "ChatWidget",
      component: ChatWidget,
    },
    {
      path: "*",
      beforeEnter() {
        location.href = "https://www.getmacha.com";
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
  },
});
